import Vue from 'vue';

Vue.mixin({
	methods: {
		generateRandomID () {
			return '_' + Math.random().toString(36).substr(2, 9);
		},

		removeLazyPreloader (el) {
			el.parentNode.classList.add('hide-preloader');
		},

		/**
		 * Remove object properties which have NULL value
		 *
		 * @param obj
		 * @return {*}
		 */
		cleanObject(obj) {
			const propNames = Object.getOwnPropertyNames(obj);
			for (let i = 0; i < propNames.length; i++) {
				if (obj[propNames[i]] === null || obj[propNames[i]] === undefined) {
					delete obj[propNames[i]];
				}
			}

			return obj;
		}
	}
});
